const zIndexes = {
  BASELAYERS: 0,
  GEOLAYERS: 10,
  COASTLINE: 19,
  ARENALAYER: 20,
  CTR: 21,
  FIR: 22,
  ADSB: 30,
  CROSS_SECTION: 40,
};

export default zIndexes;
